import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css, keyframes } from '@emotion/react';
import { useCallback, useState } from 'react';
import { useInstanceId } from '../../../context/instance/instanceContext';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { thunkSetScene } from '../../../redux/actions/sceneActions';
import { useAppDispatch } from '../../../redux/store';
import { getInstanceSelector } from '../../../utils/uiUtils';
import { TRANSITION_ANIMATION_ARIA_LABEL, TRANSITION_ANIMATION_COLORS, TRANSITION_CONTAINER_Z_INDEX, TRANSITION_HALF_DURATION_MS } from './transitionAnimationStyles';
import { TransitionMessageDisplay } from './transitionMessageDisplay';
/**
 * Transparent backdrop that prevents clicks from passing through,
 * so the user can't interact with the page or attempt to join a room while already joining one.
 */
const BACKDROP_CSS = css `
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: ${TRANSITION_CONTAINER_Z_INDEX};
  background-color: rgba(0, 0, 0, 0);
  overflow: hidden;
`;
export function getTransitionAnimationMaxCircleDiameterPx(instanceId) {
    const instanceContainer = document.querySelector(getInstanceSelector(instanceId));
    const { width, height } = instanceContainer.getBoundingClientRect();
    // get the width and height that the circle radius must cover:
    const radiusWidth = width / 2;
    const radiusHeight = height / 2;
    // use Pythagorean theorem:
    const maxRadius = Math.sqrt(Math.pow(radiusWidth, 2) + Math.pow(radiusHeight, 2));
    return maxRadius * 2;
}
export const TransitionLoadingAnimation = ({ transition }) => {
    const instanceId = useInstanceId();
    const [maxCircleDiameterPx] = useState(getTransitionAnimationMaxCircleDiameterPx(instanceId));
    const socketSend = useSocketSend();
    const dispatch = useAppDispatch();
    const { transitionSceneType, transitionAnimationMessage } = transition;
    const onAnimationEnd = useCallback(() => {
        dispatch(thunkSetScene(transitionSceneType, socketSend));
    }, [dispatch, socketSend, transitionSceneType]);
    const keyframesName = keyframes `
    0% {
      width: 0;
      height: 0;
    }
    50% {
      width: ${maxCircleDiameterPx}px;
      height: ${maxCircleDiameterPx}px;
    }
    100% {
      width: ${maxCircleDiameterPx}px;
      height: ${maxCircleDiameterPx}px;
    }
  `;
    return (_jsxs("div", { css: BACKDROP_CSS, "aria-label": TRANSITION_ANIMATION_ARIA_LABEL, children: [TRANSITION_ANIMATION_COLORS.map((color, i) => (_jsx("div", { css: css `
            width: 0;
            height: 0;
            position: absolute;
            background-color: ${color};
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            animation: ${keyframesName} ${TRANSITION_HALF_DURATION_MS}ms ease-in forwards;
            animation-delay: ${Math.round((i * TRANSITION_HALF_DURATION_MS) / 20)}ms;
          `, onAnimationEnd: i === TRANSITION_ANIMATION_COLORS.length - 1 ? onAnimationEnd : undefined }, i))), _jsx(TransitionMessageDisplay, { transitionAnimationMessage: transitionAnimationMessage })] }));
};
